import { memo, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { MarketingChrome, scrollToSection } from "../components/MarketingChrome";
import {
  IconArrow,
  IconCheck,
  IconEye,
  IconMail,
  IconMic,
  IconUser,
  IconWallet,
  IconApply,
  IconJoin,
  PayIcon,
  ClearRightIcon,
  SecureIcon
} from "../components/Icons";


const FAQS = [
  {
    q: "How much do contributors earn?",
    a: "Contributors earn $0.05 for every approved voice note.",
  },
  {
    q: "What will I record?",
    a: "You'll record short voice notes on different topics. Just speak naturally in your own words.",
  },
  {
    q: "How do I get paid?",
    a: "Payments are made through PayPal or Wise for approved voice notes. You'll receive earnings based on the number of recordings approved.",
  },
  // {
  //   q: "Can I change my country later?",
  //   a: "Yes. You can stop contributing whenever you like. Work already accepted stays payable under the Contributor Terms.",
  // },
  {
    q: "Who can apply?",
    a: "Anyone aged 18 or older with a clear speaking voice and access to a smartphone or microphone can apply. No previous experience is required.",
  },
];

/** Bar geometry from the Figma hero waveform. The first half is gold, the rest amber. */
const HERO_BARS: Array<[number, number, number, 0 | 1]> = [
  [143.918, 73.5979, 4.37216, 0], [151.203, 72.8694, 5.82955, 0], [158.492, 74.3267, 2.91477, 0],
  [165.777, 72.8694, 5.82955, 0], [173.066, 69.9546, 11.6591, 0], [180.352, 69.2261, 13.1165, 0],
  [187.637, 69.9546, 11.6591, 0], [194.926, 72.8694, 5.82955, 0], [202.211, 72.8694, 5.82955, 0],
  [209.5, 72.8694, 5.82955, 0], [216.785, 69.2258, 13.1165, 0], [224.074, 67.0398, 17.4886, 0],
  [231.359, 69.9546, 11.6591, 0], [238.648, 67.7686, 16.0312, 0], [245.934, 60.4814, 30.6051, 0],
  [253.223, 55.3806, 40.8068, 0], [260.508, 59.0239, 33.5199, 0], [267.793, 67.0398, 17.4886, 0],
  [275.082, 67.7686, 16.0312, 0], [282.367, 66.311, 18.946, 0], [289.656, 69.9546, 11.6591, 0],
  [296.941, 67.0398, 17.4886, 0], [304.23, 67.0398, 17.4886, 0], [311.516, 66.311, 18.946, 0],
  [318.805, 54.6521, 42.2642, 0], [326.09, 46.6365, 58.2955, 0], [333.379, 48.0938, 55.3807, 0],
  [340.664, 60.4814, 30.6051, 0], [347.949, 65.5823, 20.4034, 0], [355.238, 55.3806, 40.8068, 0],
  [362.523, 55.3806, 40.8068, 0], [369.812, 63.3962, 24.7756, 0], [377.098, 69.2258, 13.1165, 0],
  [384.387, 67.7686, 16.0312, 0], [391.672, 58.2954, 34.9773, 0], [398.961, 48.0938, 55.3807, 0],
  [406.246, 45.9077, 59.7528, 0], [413.531, 55.3806, 40.8068, 0], [420.82, 65.5825, 20.4034, 0],
  [428.105, 50.2798, 51.0085, 1], [435.395, 45.9077, 59.7528, 1], [442.68, 52.4658, 46.6364, 1],
  [449.969, 63.3962, 24.7756, 1], [457.254, 69.2258, 13.1165, 1], [464.543, 67.0398, 17.4886, 1],
  [471.828, 59.0242, 33.5199, 1], [479.117, 53.9233, 43.7216, 1], [486.402, 57.5669, 36.4347, 1],
  [493.688, 68.4971, 14.5739, 1], [500.977, 53.9233, 43.7216, 1], [508.262, 45.179, 61.2102, 1],
  [515.551, 48.0938, 55.3807, 1], [522.836, 59.7529, 32.0625, 1], [530.125, 69.9546, 11.6591, 1],
  [537.41, 66.311, 18.946, 1], [544.699, 69.9546, 11.6591, 1], [551.984, 66.311, 18.946, 1],
  [559.273, 65.5823, 20.4034, 1], [566.559, 70.6833, 10.2017, 1], [573.844, 62.6677, 26.233, 1],
  [581.133, 55.3806, 40.8068, 1], [588.418, 54.6521, 42.2642, 1], [595.707, 61.939, 27.6903, 1],
  [602.992, 71.4119, 8.74432, 1], [610.281, 67.0398, 17.4886, 1], [617.566, 67.0398, 17.4886, 1],
  [624.855, 69.9546, 11.6591, 1], [632.141, 72.8694, 5.82955, 1], [639.43, 72.8694, 5.82955, 1],
  [646.715, 71.4121, 8.74432, 1], [654, 67.7686, 16.0312, 1], [661.289, 67.0398, 17.4886, 1],
  [668.574, 69.9546, 11.6591, 1], [675.863, 73.5979, 4.37216, 1], [683.148, 72.8694, 5.82955, 1],
  [690.438, 72.8694, 5.82955, 1], [697.723, 73.5979, 4.37216, 1], [705.012, 74.3267, 2.91477, 1],
];

const stories = [
  {
    id: 1,
    quote:
      "Honestly... I wasn't really sure how this would work at first. But yeah, it's pretty simple. :)",
    name: "Maya R.",
    role: "Voice contributor",
    image: new URL("../assets/profile.png", import.meta.url).href,
    featured: false,
  },
  {
    id: 2,
    quote:
      "Hey, just wanted to let you know... I got my first payment! Wasn't expecting the whole process to be this easy haha.",
    name: "Daniel K.",
    role: "Voice contributor",
    image: new URL("../assets/profile1.png", import.meta.url).href,
    featured: true,
  },
  {
    id: 3,
    quote:
      "At first I thought I'd have to spend a lot of time on this haha...But no, I just record what I think and submit it.",
    name: "Sofia Louis",
    role: "Voice contributor",
    image: null,
    initials: "SL",
    featured: false,
  },
];


const WAVE_MID = 75.784;

const HeroWave = memo(function HeroWave({ id }: { id: string }) {
  const barsRef = useRef<Array<SVGRectElement | null>>([]);

  useEffect(() => {
    const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (motion.matches) return;

    const heights = HERO_BARS.map((bar) => bar[2]);
    const count = heights.length;
    let frame = 0;
    const startTime = performance.now();

    const tick = (now: number) => {
      frame = requestAnimationFrame(tick);
      if (document.hidden) return;

      const t = (now - startTime) / 1000;
      // Slow drift of the designed shape, plus a softer swell that travels right.
      const shift = t * 0.28;

      for (let i = 0; i < count; i++) {
        const node = barsRef.current[i];
        if (!node) continue;

        let src = i - shift;
        src = ((src % count) + count) % count;
        const i0 = Math.floor(src);
        const i1 = (i0 + 1) % count;
        const f = src - i0;
        const smooth = f * f * (3 - 2 * f);
        const base = heights[i0] + (heights[i1] - heights[i0]) * smooth;

        const wave =
          0.7 * Math.sin(t * 1.15 - i * 0.34) +
          0.3 * Math.sin(t * 0.62 - i * 0.15);
        const swell = 0.88 + 0.16 * wave;
        const h = Math.max(2.2, base * swell);

        node.setAttribute("y", (WAVE_MID - h / 2).toFixed(2));
        node.setAttribute("height", h.toFixed(2));
      }
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="852" height="130" viewBox="0 0 852 130" fill="none" className="wave-svg">
      {HERO_BARS.map(([x, y, h, tone], i) => (
        <rect
          key={x}
          ref={(node) => {
            barsRef.current[i] = node;
          }}
          x={x}
          y={y}
          width="2.18608"
          height={h}
          rx="1.09304"
          fill={tone ? `url(#${id}-wave-amber)` : `url(#${id}-wave-gold)`}
        />
      ))}
      <defs>
        <linearGradient id={`${id}-wave-gold`} x1="0" y1="0" x2="1" y2="0">
          <stop stopColor="#FFC83D" />
          <stop offset="1" stopColor="#FF8A32" />
        </linearGradient>
        <linearGradient id={`${id}-wave-amber`} x1="0" y1="0" x2="1" y2="0">
          <stop stopColor="#FF8A32" />
          <stop offset="1" stopColor="#FF6B2C" />
        </linearGradient>
      </defs>
    </svg>
  );
});

export function Landing() {
  const [open, setOpen] = useState<number | null>(0);

  useEffect(() => {
    const id = window.location.hash.replace("#", "");
    if (!id) return;
    const timer = window.setTimeout(() => scrollToSection(id), 50);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <MarketingChrome>
      <div className="landing">
        <section className="hero">
          <div className="hero-glows" aria-hidden="true">
            <span className="glow-center" />
            <span className="glow-side glow-left" />
            <span className="glow-side glow-right" />
          </div>
          <div className="kicker"><i /> Paid voice contributor network</div>
          <h1>
            Your voice
            <br />
            <em>has value</em>
          </h1>
          <p className="hero-lede">Record short voice notes. Get paid for every approved one.</p>
          <div className="hero-buttons">
            <Link to="/apply" className="btn btn-primary">
              Apply to contribute <IconArrow width={20} height={20} />
            </Link>
            <Link to="/how-it-works" className="btn btn-ghost">See how it works</Link>
            {/* <button type="button" className="btn btn-ghost" onClick={() => scrollToSection("how")}>
              See how it works
            </button> */}
          </div>

          <div className="hero-stage" aria-hidden="true">
            <div className="hero-watermark">
            <svg viewBox="0 0 1280.817 352.336" fill="none" aria-hidden="true">
              <g opacity="0.1">
                <path d="M58.1408 0V274.994H0V0H58.1408Z" fill="url(#inputry-mark)" fillOpacity="0.3" />
                <path d="M156.431 155.758V274.994H99.23V68.7484H153.745V105.137H156.162C160.728 93.1416 168.381 83.6528 179.123 76.6706C189.865 69.5988 202.89 66.0629 218.197 66.0629C232.52 66.0629 245.007 69.196 255.66 75.4621C266.312 81.7283 274.592 90.6799 280.5 102.317C286.408 113.865 289.362 127.65 289.362 143.673V274.994H232.162V153.878C232.251 141.257 229.028 131.41 222.494 124.338C215.959 117.177 206.963 113.596 195.505 113.596C187.806 113.596 181.003 115.252 175.095 118.564C169.276 121.876 164.711 126.71 161.399 133.066C158.176 139.332 156.52 146.896 156.431 155.758Z" fill="url(#inputry-mark)" fillOpacity="0.3" />
                <path d="M328.773 352.336V68.7484H385.168V103.391H387.72C390.226 97.8412 393.851 92.2017 398.596 86.4726C403.43 80.6541 409.696 75.8202 417.394 71.971C425.182 68.0323 434.85 66.0629 446.397 66.0629C461.436 66.0629 475.311 70.0016 488.022 77.8791C500.734 85.667 510.894 97.4383 518.503 113.193C526.112 128.859 529.916 148.507 529.916 172.14C529.916 195.145 526.201 214.57 518.771 230.415C511.431 246.169 501.405 258.12 488.694 266.266C476.072 274.322 461.928 278.351 446.263 278.351C435.163 278.351 425.719 276.515 417.931 272.845C410.233 269.175 403.922 264.565 398.999 259.015C394.075 253.375 390.316 247.691 387.72 241.962H385.974V352.336H328.773ZM384.766 171.871C384.766 184.135 386.466 194.832 389.868 203.963C393.27 213.093 398.193 220.21 404.638 225.312C411.083 230.325 418.916 232.832 428.136 232.832C437.446 232.832 445.323 230.28 451.768 225.178C458.214 219.986 463.092 212.825 466.404 203.694C469.806 194.474 471.507 183.866 471.507 171.871C471.507 159.965 469.851 149.492 466.539 140.451C463.226 131.41 458.348 124.338 451.903 119.236C445.457 114.133 437.535 111.582 428.136 111.582C418.826 111.582 410.949 114.044 404.504 118.967C398.148 123.89 393.27 130.873 389.868 139.914C386.466 148.955 384.766 159.607 384.766 171.871Z" fill="url(#inputry-mark)" fillOpacity="0.3" />
                <path d="M694.638 187.178V68.7484H751.839V274.994H696.921V237.531H694.773C690.118 249.616 682.375 259.328 671.543 266.669C660.801 274.009 647.687 277.679 632.201 277.679C618.415 277.679 606.286 274.546 595.812 268.28C585.339 262.014 577.148 253.107 571.24 241.559C565.422 230.012 562.468 216.182 562.378 200.069V68.7484H619.579V189.864C619.669 202.038 622.936 211.661 629.381 218.733C635.826 225.805 644.464 229.34 655.296 229.34C662.189 229.34 668.634 227.774 674.631 224.641C680.629 221.418 685.463 216.674 689.133 210.408C692.893 204.142 694.728 196.398 694.638 187.178Z" fill="url(#inputry-mark)" fillOpacity="0.3" />
                <path d="M901.623 68.7484V111.716H777.42V68.7484H901.623ZM805.617 19.3355H862.818V211.616C862.818 216.898 863.624 221.015 865.235 223.969C866.846 226.834 869.084 228.848 871.949 230.012C874.903 231.176 878.304 231.757 882.154 231.757C884.839 231.757 887.525 231.534 890.21 231.086C892.896 230.549 894.954 230.146 896.387 229.878L905.383 272.442C902.519 273.338 898.49 274.367 893.298 275.531C888.106 276.784 881.796 277.545 874.366 277.813C860.58 278.351 848.495 276.515 838.112 272.308C827.817 268.101 819.806 261.566 814.077 252.704C808.348 243.842 805.528 232.653 805.617 219.136V19.3355Z" fill="url(#inputry-mark)" fillOpacity="0.3" />
                <path d="M933.213 274.994V68.7484H988.668V104.734H990.816C994.576 91.9331 1000.89 82.2654 1009.75 75.7307C1018.61 69.1065 1028.82 65.7944 1040.36 65.7944C1043.23 65.7944 1046.32 65.9734 1049.63 66.3315C1052.94 66.6896 1055.85 67.1819 1058.36 67.8085V118.564C1055.67 117.759 1051.96 117.042 1047.21 116.416C1042.47 115.789 1038.13 115.476 1034.19 115.476C1025.77 115.476 1018.25 117.311 1011.63 120.981C1005.09 124.562 999.902 129.575 996.053 136.02C992.293 142.465 990.414 149.895 990.414 158.309V274.994H933.213Z" fill="url(#inputry-mark)" fillOpacity="0.3" />
                <path d="M1123.85 352.336C1116.6 352.336 1109.8 351.754 1103.44 350.59C1097.17 349.516 1091.98 348.128 1087.86 346.428L1100.75 303.728C1107.47 305.787 1113.51 306.906 1118.88 307.085C1124.34 307.264 1129.04 306.011 1132.98 303.326C1137.01 300.64 1140.28 296.075 1142.78 289.63L1146.14 280.902L1072.15 68.7484H1132.31L1175.01 220.21H1177.16L1220.26 68.7484H1280.82L1200.65 297.283C1196.81 308.383 1191.57 318.051 1184.94 326.286C1178.41 334.611 1170.13 341.012 1160.1 345.488C1150.08 350.053 1137.99 352.336 1123.85 352.336Z" fill="url(#inputry-mark)" fillOpacity="0.3" />
              </g>
              <defs>
                <linearGradient id="inputry-mark" x1="0" y1="176.168" x2="1280.82" y2="176.168" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#3E3E3E" />
                  <stop offset="0.480769" stopColor="white" />
                  <stop offset="1" stopColor="#3E3E3E" />
                </linearGradient>
              </defs>
            </svg>
            </div>
            <div className="float-card float-left">
              <span className="float-icon"><IconMic width={20} height={20} /></span>
              <div>
                <strong>00:32</strong>
                <small>Recording complete</small>
              </div>
            </div>
            <HeroWave id="hero" />
            <div className="float-card float-right">
              <span className="float-icon ok"><IconCheck width={20} height={20} /></span>
              <div>
                <strong>Approved</strong>
                <small>Paid through PayPal/Wise</small>
              </div>
              <b className="float-amount">+0.05</b>
            </div>
          </div>

          <div className="stat-row">
            <div className="stat-row-box first">
              <strong>$3</strong>
              <span>Hourly Earnings</span>
            </div>
            <div className="stat-row-box sec">
              <strong>PayPal/Wise</strong>
              <span>Payouts for approved recordings</span>
            </div>
            <div className="stat-row-box third">
              <strong>10–40s</strong>
              <span>Short, natural voice notes</span>
            </div>
            <div className="stat-row-box fourth mobile-stats">
              <strong>Remote</strong>
              <span>Phone or laptop</span>
            </div>
          </div>
        </section>

        <div className="section-grid landing-grid">
            <section className="section-block centered" id="how">
              <div className="kicker"><i /> How it works</div>
              <h2 className="fourstep-heading">Four <span className="color-text">simple steps</span></h2>
              <div className="step-grid">
                {[
                  ["01", "Apply", "Tell us about yourself", IconUser],
                  ["02", "Record a sample", "Share a short voice sample", IconMic],
                  ["03", "Get invited", "We'll review and send invites to the selected!", IconMail],
                  ["04", "Record & earn", "Get paid via PayPal/Wise", IconWallet],
                ].map(([num, title, copy, Icon]) => (
                  <article key={String(num)} className="step-card">
                    <div className="step-card-top">
                      <span className="icon-tile"><Icon width={28} height={28} /></span>
                      <span className="step-ghost">{num as string}</span>
                    </div>
                    <h3>{title as string}</h3>
                    <p>{copy as string}</p>
                  </article>
                ))}
              </div>
            </section>

            <section className="section-block" id="earnings">
              <div className="pay-band">
                <div className="pay-band-glow"></div>
                <div className="pay-band-content">
                  <div>
                    <div className="kicker"><i /> CONTRIBUTORS EARN</div>
                    <h2>
                      Simple,{" "}
                      <br />
                      transparent pay.
                    </h2>
                    <p className="legal-copy">Earn for every approved voice note, with payments made via PayPpal or Wise</p>
                    {/* <Link to="/how-it-works" className="mini-chip chip-link">
                      Rates may vary by country
                    </Link> */}
                  </div>
                  <div>
                    <div className="pay-figure">$3</div>
                    <div className="legal-copy pay-caption">
                      <span className="pay-caption-full">Up to $3 per Hour</span>
                      <span className="pay-caption-short">Up to $3 per Hour</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="flow-chips">
                <span><IconMic width={22} height={22} /> Record</span>
                
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.16797 10H15.8346M10.8346 15L15.8346 10L10.8346 5" stroke="#4A4A4A" strokeWidth="1.83333" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                <span><IconEye width={22} height={22} /> Review</span>
                
                  <svg className="flow-mid" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.16797 10H15.8346M10.8346 15L15.8346 10L10.8346 5" stroke="#4A4A4A" strokeWidth="1.83333" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                <i className="flow-break" aria-hidden="true" />
                <span><IconCheck width={22} height={22} /> Approved</span>
                
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.16797 10H15.8346M10.8346 15L15.8346 10L10.8346 5" stroke="#4A4A4A" strokeWidth="1.83333" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                <span><IconCard width={22} height={22} /> Paid</span>
              </div> */}
            </section>

            <section className="section-block centered" id="rights">
              <div className="kicker"> WHY CONTRIBUTE</div>
              <h2 className="stock-photo-heading">
                Like a stock-photo library. 
                <br />
                But with your voice.
              </h2>
              <div className="rights-grid stock-photo-rights-grid">
                <article className="soft-card">
                  <div className="icon-tile"><IconMic width={20} height={20} /></div>
                  <h3>You record it</h3>
                  <p>Your own voice, once</p>
                </article>
                <article className="soft-card">
                  <div className="icon-tile">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="29"
                      height="29"
                      viewBox="0 0 29 29"
                      fill="none"
                    >
                      <path
                        d="M4.83203 12.0833V16.9167H8.45703L18.1237 21.75V7.25L8.45703 12.0833H4.83203Z"
                        stroke="#FFC83D"
                        strokeWidth={2.41667}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22.957 10.875C24.1654 12.0833 24.1654 16.9167 22.957 18.125"
                        stroke="#FFC83D"
                        strokeWidth={2.41667}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h3>Inputry may publish it</h3>
                  <p>Approved clips, in content.</p>
                </article>
                <article className="soft-card">
                  <div className="icon-tile"><ClearRightIcon /></div>
                  <h3>The Terms cover it</h3>
                  <p>Reviewed before you join.</p>
                </article>
              </div>
              <Link to="/terms" className="btn btn-ghost btn-sm center-btn">
                Read Contributor Terms <IconArrow width={17} height={17} />
              </Link>
            </section>

            <section className="section-block centered" id="stories">
              <div className="kicker"> CONTRIBUTORS STORIES</div>
              <h2 className="stock-photo-heading">
                Real voices. Real experiences. 
              </h2>
              <div className="rights-grid stock-photo-rights-grid stories-section">
                {stories.map((story) => (
                  <div
                    className={`stories-row ${story.featured ? "featured" : ""}`}
                    key={story.id}
                  >
                    <div className="stories-quote">“</div>

                    <div className="stories-text">
                      <span>{story.quote}</span>
                    </div>

                    <div className="stories-profile">
                      <div className="picture">
                        {story.image ? (
                          <img src={story.image} alt={story.name} />
                        ) : (
                          <div className="picture-initials">
                            {story.initials}
                          </div>
                        )}
                      </div>

                      <div className="profile-info">
                        <div className="profile-name">{story.name}</div>
                        <div className="profile-role">{story.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="section-block" style={{display:"none"}}>
              <div className="review-head application-review-head">
                <div>
                  <div className="kicker"> Invite only</div>
                  <h2>
                    Every contributor is
                    <br />
                    reviewed.
                  </h2>
                </div>
                <span className="mail-tile bigmail">
                  <svg xmlns="http://www.w3.org/2000/svg" width="89" height="79" viewBox="0 0 89 79" fill="none">
                      <path d="M47.6667 65C47.6667 63.5267 47.84 62.0967 48.0567 60.6667H8.66667V17.3333L43.3333 39L78 17.3333V39.39C81.12 39.91 84.0233 40.9933 86.6667 42.51V8.66667C86.6667 3.9 82.7667 0 78 0H8.66667C3.9 0 0 3.9 0 8.66667V60.6667C0 65.4333 3.9 69.3333 8.66667 69.3333H48.0567C47.84 67.9033 47.6667 66.4733 47.6667 65ZM78 8.66667L43.3333 30.3333L8.66667 8.66667H78ZM68.25 78.6933L56.3333 65.6933L61.36 60.6667L68.25 67.5567L83.8067 52L88.8333 58.11L68.25 78.6933Z" fill="url(#paint0_linear_64_496)"/>
                      <defs>
                      <linearGradient id="paint0_linear_64_496" x1="0" y1="39.3467" x2="88.8333" y2="39.3467" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#FFC83D"/>
                      <stop offset="1" stopColor="#FF6B2C"/>
                      </linearGradient>
                      </defs>
                    </svg>
                </span>
              </div>
              <div className="review-rail">
                {[
                  ["Apply", "Application", IconApply],
                  ["Sample", "Voice sample", IconMic],
                  ["Review", "Team review", IconEye],
                  ["Invite", "Email invitation", IconMail],
                  ["Join", "Create account", IconJoin],
                ].map(([label, long, Icon], index) => (
                  <div className="node" key={String(label)}>
                    {index > 0 && <i className="node-line" />}
                    <span className="icon-tile"><Icon width={20} height={20} /></span>
                    <span className="node-copy">
                      <span className="node-label">{label as string}</span>
                      <span className="node-label-long">{long as string}</span>
                      <span className="node-index">0{index + 1}</span>
                    </span>
                  </div>
                ))}
              </div>
              <Link to="/how-it-works" className="text-link review-more">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12 3.3335H4C2.89543 3.3335 2 4.22893 2 5.3335V10.6668C2 11.7714 2.89543 12.6668 4 12.6668H12C13.1046 12.6668 14 11.7714 14 10.6668V5.3335C14 4.22893 13.1046 3.3335 12 3.3335Z" stroke="#FFC83D" strokeWidth="1.46667" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2.66797 5L8.0013 9L13.3346 5" stroke="#FFC83D" strokeWidth="1.46667" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Your invitation is tied to your application email. 
              </Link>
            </section>

            <section className="section-block signup-know" style={{display:"none"}}>
              <div>
                <div className="kicker">TRUST</div>
                <h2>
                  Know what you're
                  <br />
                  signing up for.
                </h2>
                <div className="btn btn-ghost btn-sm landing-rates">
                  Rates may vary by country 
                </div>
                <div className="chip-row signup-chips">
                  <span className="mini-chip">Privacy Policy  →</span>
                  <span className="mini-chip">Contributor Terms  →</span>
                  <span className="mini-chip">Contact Inputry  →</span>
                </div>
              </div>
              <div className="know-grid">
                {[
                  ["Clear pay", PayIcon],
                  ["Clear rights", ClearRightIcon],
                  ["Human review", IconJoin],
                  ["Secure account", SecureIcon],
                ].map(([label, Icon]) => (
                  <article key={String(label)} className="soft-card">
                    <span className="icon-tile"><Icon width={20} height={20} /></span>
                    <h3>{label as string}</h3>
                  </article>
                ))}
              </div>
              <HeroWave id="know" />
            </section>

            <section className="section-block centered" id="faq">
              {/* <div className="kicker"> FAQ</div> */}
              <h2>Frequently asked questions</h2>
              <div className="faq-list">
                {FAQS.map((item, index) => (
                  <details
                    key={item.q}
                    className="faq-item"
                    open={open === index}
                    onToggle={(event) => {
                      if ((event.currentTarget as HTMLDetailsElement).open) setOpen(index);
                    }}
                  >
                    <summary>
                      {item.q}
                      <span>{open === index ? "–" : "+"}</span>
                    </summary>
                    <p>{item.a}</p>
                  </details>
                ))}
              </div>
            </section>

            <section className="closing">
              <div className="closing-glow"></div>
              <div className="closing-content">
                  <h2 className="closing-heading">Ready to add your voice?</h2>
                  <p className="legal-copy" style={{ marginBottom: 30 }}>
                    Apply and submit a short voice sample.
                  </p>
                  <Link to="/apply" className="btn btn-primary">
                    Apply to contribute <IconArrow width={20} height={20} />
                  </Link>
                  <p className="fine">
                    Already invited? <Link to="/signup">Create your account</Link>
                  </p>
                </div>
            </section>
          </div>
      </div>
    </MarketingChrome>
  );
}
